import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button, Textarea } from '@any-ui-react/core';

export interface CustomerNoteActivityFormProps {
  id: string;
  note: string;
  onCancel?: () => void;
  onUpdateNoteActivity?: (payload: { id: string; note: string }) => Promise<boolean>;
}

export const CustomerNoteActivityForm = ({
  id,
  note,
  onCancel,
  onUpdateNoteActivity,
}: CustomerNoteActivityFormProps) => {
  const { t } = useTranslation('shared');

  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm<{ id: string; note: string }>({
    defaultValues: {
      id,
      note,
    },
  });

  return (
    <form
      className="flex w-full flex-col gap-2"
      onSubmit={onUpdateNoteActivity && handleSubmit(onUpdateNoteActivity)}
    >
      <Textarea {...register('note')} className="w-full" />
      <div className="flex gap-2 self-end">
        <Button disabled={isSubmitting} variant="default" onClick={onCancel}>
          {t('shared.button.cancel', { ns: 'shared' })}
        </Button>
        <Button loading={isSubmitting} variant="primary" type="submit">
          {t('shared.button.save', { ns: 'shared' })}
        </Button>
      </div>
    </form>
  );
};
